export const PERMISSIONS = {
  ALL_MANAGE: 'all:manage',
  // Supplier Product Permissions
  SUPPLIER_PRODUCT_READ: 'supplier_product:read',

  // SKU Permissions
  MY_SKU_READ: 'my_sku:read',
  MY_SKU_CREATE: 'my_sku:create',
  MY_SKU_DELETE: 'my_sku:delete',
  MY_SKU_INFO_DOWNLOAD: 'my_sku_info:download',

  // Integration Permissions
  AIROXY_INTEGRATION_UPLOAD: 'airoxy_integration:upload',

  // Order Permissions
  ORDER_READ: 'order:read',
  ORDER_CREATE: 'order:create',
  ORDER_PAY: 'order:pay',

  // Invoice Permissions
  INVOICE_DOWNLOAD: 'invoice:download',

  // Wallet Permissions
  WALLET_READ: 'wallet:read',
  WALLET_TOPUP: 'wallet:topup',
  FLEX_READ: 'flex:read',

  // File Download Permissions
  SKU_FILE_DOWNLOAD: 'sku_file:download',
  MONTHLY_STATEMENT_DOWNLOAD: 'monthly_statement:download',
  AUTH_LETTER_DOWNLOAD: 'auth_letter:download',

  // Ticket Permissions
  TICKETS_READ: 'tickets:read',
  TICKETS_REPLY: 'tickets:reply',
  TICKETS_EXPORT: 'tickets:export',

  // Sales Data Permissions
  SALES_DATA_READ: 'sales_data:read',

  // Account Permissions
  MY_ACCOUNT_READ: 'my_account:read',
  MY_ACCOUNT_UPDATE: 'my_account:update',

  // Sub Account Permissions
  SUB_ACCOUNT_READ: 'sub_account:read',
  SUB_ACCOUNT_CREATE: 'sub_account:create',
  SUB_ACCOUNT_UPDATE: 'sub_account:update',
  SUB_ACCOUNT_DELETE: 'sub_account:delete',

  // Shopify Permissions
  SHOPIFY_SETTING_READ: 'shopify_setting:read',
  SHOPIFY_PRODUCT_READ: 'shopify_product:read',
  SHOPIFY_MY_PRODUCT_READ: 'shopify_my_product:read',
  SHOPIFY_MY_PRODUCT_CREATE: 'shopify_my_product:create',
  SHOPIFY_MY_PRODUCT_DELETE: 'shopify_my_product:delete',
  SHOPIFY_PRODUCT_CONTENT_UPDATE_READ: 'shopify_product_content_update:read',
  SHOPIFY_AUTO_PRICE_SYNC_READ: 'shopify_auto_price_sync:read',

  // Wholesale Permissions
  WHOLESALE_PRODUCT_READ: 'wholesale_product:read',
  WHOLESALE_ORDER_CREATE: 'wholesale_order:create',
} as const;

export type PermissionName = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

export const PERMISSION_KEYS = Object.keys(PERMISSIONS) as (keyof typeof PERMISSIONS)[];

export const PERMISSION_VALUES = Object.values(PERMISSIONS) as PermissionName[];
